<template>
  <details :open="expanded" class="text-disclosure">
    <summary class="small fw-semibold">
      {{ label }}
      <span class="text-muted fw-normal"
        >· {{ text.length.toLocaleString() }} chars</span
      >
    </summary>
    <pre class="border rounded bg-body p-3 my-2">{{
      showAll ? text : text.slice(0, previewChars)
    }}</pre>
    <button
      v-if="text.length > previewChars"
      class="btn btn-link btn-sm p-0"
      @click="showAll = !showAll"
    >
      {{
        showAll
          ? "Show preview"
          : `Show all ${text.length.toLocaleString()} chars`
      }}
    </button>
  </details>
</template>
<script setup lang="ts">
import { ref } from "vue";
withDefaults(
  defineProps<{ label: string; text: string; expanded?: boolean }>(),
  { expanded: false }
);
const previewChars = 2000;
const showAll = ref(false);
</script>
<style scoped lang="scss">
summary {
  color: var(--phoenix-primary, #1f4d33);
  cursor: pointer;
}
pre {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-height: 32rem;
  overflow: auto;
  font-size: 0.78rem;
}
</style>
